export const WELCOME_OFFER_MODAL_DELAY = parseInt(import.meta.env.VITE_WELCOME_OFFER_MODAL_DELAY || '5') * 60 * 1000;